module.exports = __webpack_public_path__ + "static/img/home_commission_1.8da3f49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_commission_1.png
// module id = FhI6
// module chunks = 1